import * as types from '../mutation-types'
import injector from 'vue-inject'

export default store => {
  store.subscribe(async mutation => {
    switch (mutation.type) {
      case types.SET_STORE:
        injector.get('storeSetting').store = store.state.store
        break
      default:
    }
  })
}
